import { toast as sonner } from "sonner";

// Sonner pauses its timer while a toast is hovered/touched or the tab is hidden, which on
// phones leaves toasts stuck on screen. This wrapper hard-dismisses every toast after its
// duration (default 5 s) no matter what.
export const TOAST_DURATION = 5000;

const hardDismiss = (id, opts) => {
  const d = opts?.duration ?? TOAST_DURATION;
  if (id === undefined || id === null || d === Infinity) return id;
  setTimeout(() => sonner.dismiss(id), d + 250);
  return id;
};

const withOpts = (opts) => (opts?.duration === Infinity ? { ...opts } : { ...opts, duration: Math.min(opts?.duration ?? TOAST_DURATION, TOAST_DURATION) });

const wrap = (fn) => (message, opts) => {
  const o = withOpts(opts);
  return hardDismiss(fn(message, o), o);
};

export const toast = Object.assign(wrap(sonner), {
  success: wrap(sonner.success),
  error: wrap(sonner.error),
  info: wrap(sonner.info),
  warning: wrap(sonner.warning),
  message: wrap(sonner.message),
  custom: wrap(sonner.custom),
  loading: sonner.loading,
  promise: sonner.promise,
  dismiss: sonner.dismiss,
  getHistory: sonner.getHistory,
});

export default toast;
